import PageBanner from './PageBanner';

export default PageBanner;
